<template>
  <div class="cinema-page">
    <!-- 顶部固定区域 -->
    <div class="page-header">
      <!-- 返回按钮 + 电影名称 -->
      <div class="header-top">
        <div class="back-btn" @click="goback">
          <van-icon name="arrow-left" size="1.2rem" />
        </div>
        <div class="movie-title">{{ movieName }}</div>
        <div class="header-placeholder"></div>
      </div>
      
      <!-- 定位 + 区域选择 + 搜索 -->
      <div class="location-bar">
        <div class="location-left">
          <!-- 城市选择 -->
          <div class="city-select" @click="selectCity">
            <van-icon name="location-o" size="1rem" color="#ee0a24" />
            <span class="city-name">{{ cityName }}</span>
            <van-icon name="arrow-down" size="0.7rem" color="#999" />
          </div>
          
          <!-- 区域选择 -->
          <div class="area-select" @click="showAreaPicker">
            <span class="area-name">{{ areaName }}</span>
            <van-icon name="arrow-down" size="0.7rem" color="#999" />
          </div>
        </div>
        
        <!-- 搜索按钮 -->
        <div class="search-btn" @click="goSearch">
          <van-icon name="search" size="1.1rem" />
        </div>
      </div>
    </div>

    <!-- 加载状态 -->
    <loading v-if="loading"></loading>

    <!-- 内容区域 -->
    <div v-else class="page-content">
      <!-- 日期Tab + 影院列表 -->
      <div v-if="data.length > 0" class="cinema-list-wrapper">
        <cinema-time-item 
          :list="data" 
          @scrollToAll="scrollToAll" 
          ref="cinemaTimeRef" 
        />
      </div>
      
      <!-- 空状态 -->
      <div v-else class="empty-state">
        <div class="empty-icon">🎬</div>
        <div class="empty-text">该电影暂无排片</div>
        <div class="empty-tip">换个城市或日期试试</div>
      </div>
    </div>

    <!-- 区域选择弹窗 -->
    <van-popup 
      v-model="showAreaPopup" 
      position="bottom" 
      round
      :style="{ maxHeight: '50%' }">
      <div class="area-popup">
        <div class="popup-header">
          <span>选择区域</span>
          <van-icon name="cross" @click="showAreaPopup = false" />
        </div>
        <div class="area-list">
          <div 
            v-for="(item, index) in areaList" 
            :key="index"
            class="area-item"
            :class="{ active: item.regionId === selectedRegionId }"
            @click="onAreaSelect(item)">
            <span>{{ item.regionName }}</span>
            <span class="cinema-count">({{ item.cinemaNum }}家)</span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import CinemaTimeItem from "../../components/movie/CinemaTimeItem.vue";

export default {
  name: "Cinema",
  components: { CinemaTimeItem },
  data() {
    return {
      loading: true,
      movieName: '',
      cityName: '',
      cityCode: '',
      areaName: '全部',
      areaList: [],
      selectedRegionId: '',
      showAreaPopup: false,
      data: [],
      futureCinemaCounts: [],
      selectTime: '',
      hotMovie: {
        regionId: '',
        cardId: '',
        cityCode: '',
        current: 1,
        filmId: '',
        size: 500,
        lat: null,
        lng: null,
      },
    };
  },
  methods: {
    goback() {
      this.$router.back();
    },
    
    selectCity() {
      this.$router.push({
        path: "/SelectAdderss",
        query: { type: 2 },
      });
    },
    
    showAreaPicker() {
      this.showAreaPopup = true;
    },
    
    onAreaSelect(item) {
      this.areaName = item.regionName;
      this.selectedRegionId = item.regionId;
      this.hotMovie.regionId = item.regionId;
      this.hotMovie.current = 1;
      this.showAreaPopup = false;
      this.queryCinemas();
    },
    
    goSearch() {
      this.$router.push({
        path: "/CinemasList",
        query: {
          regionId: this.selectedRegionId,
          cityCode: this.cityCode,
          filmId: this.hotMovie.filmId,
          type: 0
        },
      });
    },
    
    queryCinemas() {
      this.$api
        .queryFutureFilmsByFilmId(this.hotMovie)
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.$Toast(res.msg);
            return;
          }
          
          this.data = res.data.futureFilms || [];
          
          if (res.data.futureCinemaCounts && res.data.futureCinemaCounts.length > 0) {
            this.futureCinemaCounts = res.data.futureCinemaCounts;
            // 更新区域列表
            if (this.futureCinemaCounts[0]?.cinemaCountList) {
              this.areaList = this.futureCinemaCounts[0].cinemaCountList;
            }
          }
          
          // 设置默认选中时间
          if (this.data.length > 0 && this.futureCinemaCounts.length > 0) {
            this.selectTime = this.futureCinemaCounts[0].showTime;
            this.updateAreaListByTime();
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error('查询影院失败:', err);
        });
    },
    
    scrollToAll(index) {
      this.selectTime = this.data[index].showTime;
      this.updateAreaListByTime();
    },
    
    updateAreaListByTime() {
      const found = this.futureCinemaCounts.find(
        item => item.showTime === this.selectTime
      );
      if (found && found.cinemaCountList) {
        this.areaList = found.cinemaCountList;
      }
    },
  },

  mounted() {
    this.hotMovie.filmId = this.$route.query.filmId;
    this.movieName = this.$route.query.movieName || '选择影院';
    this.hotMovie.cardId = localStorage.getItem("cardId");
    this.hotMovie.lat = localStorage.getItem('latitude');
    this.hotMovie.lng = localStorage.getItem('longitude');
    this.hotMovie.cityCode = localStorage.getItem('cityCode');
    this.cityCode = localStorage.getItem('cityCode');
    this.cityName = localStorage.getItem('address') || '定位中...';
    
    document.title = this.movieName;
    this.queryCinemas();
  },
};
</script>

<style lang='scss' scoped>
.cinema-page {
  height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem 1rem;
  
  .back-btn {
    width: 2rem;
    display: flex;
    align-items: center;
  }
  
  .movie-title {
    flex: 1;
    text-align: center;
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .header-placeholder {
    width: 2rem;
  }
}

.location-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 1rem 0.8rem;
  border-top: 1px solid #f5f5f5;
}

.location-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.city-select, .area-select {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.4rem 0.6rem;
  background: #f8f8f8;
  border-radius: 1rem;
  font-size: 0.85rem;
  
  &:active {
    background: #f0f0f0;
  }
}

.city-name {
  max-width: 4.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
}

.area-name {
  max-width: 4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #666;
}

.search-btn {
  width: 2.2rem;
  height: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f8f8;
  border-radius: 50%;
  
  &:active {
    background: #f0f0f0;
  }
}

.page-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cinema-list-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 1rem;
  text-align: center;
  
  .empty-icon {
    font-size: 4rem;
    margin-bottom: 1rem;
  }
  
  .empty-text {
    font-size: 1.1rem;
    color: #333;
    font-weight: 500;
    margin-bottom: 0.5rem;
  }
  
  .empty-tip {
    font-size: 0.9rem;
    color: #999;
  }
}

/* 区域选择弹窗 */
.area-popup {
  padding-bottom: env(safe-area-inset-bottom);
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #f5f5f5;
  
  span {
    font-size: 1rem;
    font-weight: 600;
    color: #333;
  }
}

.area-list {
  max-height: 40vh;
  overflow-y: auto;
}

.area-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #f8f8f8;
  
  &:active, &.active {
    background: #fff5f5;
    color: #ee0a24;
  }
  
  .cinema-count {
    font-size: 0.85rem;
    color: #999;
  }
}
</style>